<template>
  <div class="home">
    <p class="homeQuote">
      <br />
      Hey, why don't we just become wet-nurses? <br /> Instead of Meals on
      Wheels, we can call ourselves <span class="logoText">eats on feets</span>. <br />
      <span class="author"> ~ Shell Walker Luttrell, 1991. </span>
    </p>
    <br />
    <span id="globalKids">
      <span id="theLikeButton">
        <div
          class="fb-like"
          data-href="https://www.facebook.com/EatsOnFeetsHome"
          data-width="450"
          data-layout="button_count"
          data-show-faces="false"
          data-send="false"
        ></div>
      </span>
    </span>
    <p>
      These words are at the foundation of the breastmilk sharing network that is known today as <span class="logoText">eats on feets</span>.
    </p>
    <img
      class="borderedImage borderedImageLeft"
      src="../assets/homepageImage.jpg"
    />
    <p class="homeHiglighted"></p>
    <p>
      Breastmilk sharing, also called community-based human milk sharing or private arrangement milksharing, is successful because parents, caretakers,
      professionals, and people just like YOU are joining together to help
      ensure that babies have access to commerce-free and safe donor milk.
      Babies need human milk to maintain optimum health. Families and
      professionals know this. Every day, donors around the world selflessly offer thousands of ounces of breastmilk through
      <span class="logoText">eats on feets</span> directly to the families of
      babies in need, making a huge difference in their lives.
    </p>
    <p>
      <span class="logoText">eats on feets</span> is a leading
      resource for community-based human milk sharing. Our
      extensive research on safe milksharing practices and our easy to implement
      <router-link to="/safeMilksharing/">4 Pillars</router-link>
      have influenced milksharing and milksharing policy since 2010.
    </p>
    <p> Please have a look around and <router-link to="/getInvolved">get involved </router-link>with <span class="logoText">eats on feets!</span>
    Contact us if you would like to write a <router-link to="/blog/">blog post</router-link> about your milksharing experience or if you would like to
      <router-link to="/blog/HowToRunAnEofPage"
        >volunteer</router-link> for a while! Most of all, help us spread the word that:</p>
    <p class="closingTag"> Community-based milksharing is normal!</p>

    <div style="clear:both;margin-top:50px">
      <hr />
      <PostPreview />
    </div>
  </div>
</template>

<script>
import PostPreview from '../components/posts/PostPreview'
export default {
  name: 'Home',
  components: { PostPreview },
  metaInfo: {
    title: 'Eats On Feets',
    description:
      'Eats on Feets is a network that facilitates local breastmilk sharing'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home {
  .logoText {
    font-family: "Lexend Exa", "Avenir", Helvetica, Arial, sans-serif !important;
    white-space: nowrap;
    font-size: 1.2em;
  }

  .homeQuote {
    font-weight: 500;
    display: block;
    margin-right: 10px;
    font-size: 1.4em;
    font-style: italic;
    margin-top: 20px;
    margin-bottom: 0px;
    .author {
      font-style: normal;
      margin-top: 15px;
      display: block;
    }
    text-align: left;
  }

  #globalKids {
    background: url(../assets/global_kids_sm.jpg) repeat-x;
    width: 196px;
    height: 233px;
    min-width: 196px;
    max-width: 196px;
    min-height: 233x;
    float: right;
    margin-right: 10px;
    position: relative;
    top: -17px;
    display: none;
  }

  .birthdayicon {
    width: 25%;
    float: right;
    margin: 1px 10px;
    margin-top: -19px;
  }

  .birthday {
    font-size: 2em;
    text-align: left;
  }

  .closingTag {
    white-space: nowrap;
    font-weight: bold;
    font-size: 1.1em;
  }
}

@media screen and (max-width: 550px) {
  .birthday {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 412px) {
  .home {
    .birthday {
      font-size: 1.4em;
    }

    .closingTag {
      font-size: 0.9em;
    }
  }
  .home .homeQuote .author {
    margin-left: 80px;
  }
}
</style>
